import { aboutMenuData } from "../data/aboutMenuData";
import { enterpriseMenuData, growData } from "../data/enterpriseMenuData";
import MegaMenuPanel from "./MegaMenuPanel";
import MenuColumn from "./MenuColumn";

const AboutDropdown = ({ isAboutOpen, handleClose, topOffset }) => {
  return (
    <MegaMenuPanel
      isOpen={isAboutOpen}
      handleClose={handleClose}
      eyebrow="ABOUT UTIVA"
      title="Get to know the company, our work and every Utiva resource."
      maxWidth={1080}
      topOffset={topOffset}
    >
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
        <MenuColumn
          title="About Utiva"
          items={aboutMenuData}
          handleClose={handleClose}
        />
        <MenuColumn
          title="Grow with Utiva"
          items={growData}
          handleClose={handleClose}
        />
        <div className="rounded-3xl bg-hire-tint-blue px-7 py-8">
          <MenuColumn
            title="Resources"
            items={enterpriseMenuData}
            handleClose={handleClose}
            variant="external"
          />
        </div>
      </div>
    </MegaMenuPanel>
  );
};

export default AboutDropdown;
